export default __webpack_public_path__ + "static/media/avatar-default.d04e51c6.svg";